import { render, staticRenderFns } from "./addRukuDiglog.vue?vue&type=template&id=017e0b10&scoped=true"
import script from "./addRukuDiglog.vue?vue&type=script&lang=js"
export * from "./addRukuDiglog.vue?vue&type=script&lang=js"
import style0 from "./addRukuDiglog.vue?vue&type=style&index=0&id=017e0b10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017e0b10",
  null
  
)

export default component.exports